import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { FaceCaptureComponent } from 'src/app/shared/components/face-capture/face-capture.component';

@Component({
  selector: 'app-photo-modal',
  templateUrl: './photo-modal.component.html',
  styleUrls: ['./photo-modal.component.css']
})
export class PhotoModalComponent implements OnInit, OnDestroy {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<PhotoModalComponent>) { }

  @ViewChild(FaceCaptureComponent) child!: FaceCaptureComponent;

  public allowTakePhoto: boolean = false;
  public imageResultRef: string = '';
  public takingPhoto: boolean = false;
  public countDownPhoto: number = 10;
  public coundDownInterval: NodeJS.Timeout | undefined = undefined;
  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    clearInterval(this.coundDownInterval);
  }

  close() {
    clearInterval(this.coundDownInterval);
    this.matDialogRef.close({});
  }

  imageResult(image: any) {
    this.takingPhoto = false;
    this.imageResultRef = image;
  }

  async clickReTakePhoto() {
    this.countDownPhoto = 10;
    this.allowTakePhoto = false;
    await this.child.startWebcam();
  }

  clickTakePhoto() {
    this.allowTakePhoto = true;
    this.takingPhoto = true;
  }

  saveImage() {
    this.matDialogRef.close({ imageResultRef: this.imageResultRef });
  }

  webcamStarted(event: any) {
    this.takingPhoto = !event;
    if (event) {
      var $this = this;
      this.coundDownInterval = setInterval(() => {
        if ($this.countDownPhoto <= 0) {
          $this.clickTakePhoto();
          clearInterval($this.coundDownInterval);
        }
        $this.countDownPhoto--;
      }, 1000);
    }
  }
}